module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p2.63d9e7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p2.png
// module id = 0mur
// module chunks = 10